/**
 * This is a store that hold left panel state
 * It could be one of the ActivePanelId
 *
 * Using useStorage from @vueuse/core allow persistance storage accross tabs/sessions
 *
 * We can import and set activePanel anywhere in our project
 * @see /src/components/partials/toolbars/Toolbar.vue
 * @see /src/components/partials/panels/ActivityPanel.vue
 */

import { useStorage } from '@vueuse/core'
import {computed} from "vue";

export const slogansSchema = useStorage<string>('home-slogan', '')
export const slogans = computed({
  get() {
    return slogansSchema.value
  },
  set(v: string) {
    slogansSchema.value = v
  },
})
